import React, { lazy, Suspense, useState } from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';

import { Loader, DialogTitleWithClose } from 'ui';
import { RoundButton } from 'ui/Buttons';

const DocumentsModal = lazy(() => import('modules/common/Modals/DocumentsModal'));

const useViewDocuments = ({
  entityId,
  companyModule,
  company,
  initialMethodologies,
  initialDocuments,
}) => {
  const { t } = useTranslation();
  const [isOpen, setIsOpen] = useState(false);
  const [defaultExpand, setDefaultExpand] = useState('all');

  const handleOpen = () => setIsOpen(true);
  const handleClose = () => setIsOpen(false);
  const toggleModal = () => setIsOpen(value => !value);
  const showViewDocumentsButton = (
    <RoundButton label={t('VIEW_DOCUMENTS')} onClick={handleOpen} marginLeft />
  );
  const viewDocumentsModal = (
    <Dialog open={isOpen} onClose={handleClose} maxWidth="sm" fullWidth>
      <DialogTitleWithClose onClose={handleClose}>{t('DOCUMENTS')}</DialogTitleWithClose>
      <Suspense fallback={<Loader center />}>
        <DocumentsModal
          defaultExpand={defaultExpand}
          defaultExpandDocuments={defaultExpand}
          entityId={entityId}
          companyModule={companyModule}
          company={company}
          initialMethodologies={initialMethodologies}
          initialDocuments={initialDocuments}
        />
      </Suspense>
    </Dialog>
  );

  return { showViewDocumentsButton, viewDocumentsModal, toggleModal, setDefaultExpand };
};

export { useViewDocuments };
